export default {    
    // GET_ORDER_TICKET_DEAL: '/api/v1/order-ticket/deal',

    POST_LOAN_GOV: '/api/v1/loan-gov',    
    POST_LOAN_GOV_MESSAGE: '/api/v1/loan-gov-log',    
}